<script>
// import axios from "axios";
// import simplebar from "simplebar-vue";
import { Translator } from 'vue-google-translate';

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      arrayOfCountries: [
        {
          code: 'en|en',
          title: 'English',
        },

        {
          code: 'en|fr',
          title: 'French',
        },

        {
          code: 'en|ar',
          title: 'Arabic',
        },

        {
          code: 'en|es',
          title: 'Spanish',
        },

        {
          code: 'en|de',
          title: 'German',
        },

        {
          code: 'en|sw',
          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',
          title: 'Kiswahili',
        },

        {

          code: 'en|lg',

          flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',

          title: 'Luganda',

        },],
    };
  },
  components: {
    Translator,
  },
  methods: {
    customEvent() {
      this.$router.push(this.$route.query.redirectFrom || { name: "default", })
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" style="background-color: black;">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <img src="@/assets/images/default.jpg" height="12" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/default.jpg" height="50" />
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h4 text-primary"> <b>{{ userData.business }} </b> </span><br> |
          <span class="h6"><i class="fas fa-map-marker-alt"></i> {{ userData.location }} </span> |
          <span class="h6"><i class="fas fa-phone-alt"></i> {{ userData.contact }} </span>
        </span>



      </div>

      <div class="d-flex">
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon" @click="initFullScreen"><i
              class="bx bx-fullscreen"></i></button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
        </b-dropdown>

        <span v-if="userData.permissions['view_reports'] == 1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content><i class="fas fa-clipboard"></i> Reports<i
                class="mdi mdi-chevron-down"></i></template>
            <div class="row">
              <div class="col-md-3" v-show="userData.permissions['savings_report'] == 1">
                <h5 class="font-size-14 mt-0">Saving Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="savingspermember">Savings Per Member</router-link></li>
                  <li><router-link to="withdrawspermember">Withdraws Per Member</router-link></li>
                  <li><router-link to="sharespermember">Shares Per Member</router-link></li>
                  <li><router-link to="monthlysavingsanalysis">Monthly Savings Analysis</router-link></li>
                  <li><router-link to="monthlywithdrawsanalysis">Monthly Withdraws Analysis</router-link></li>
                  <li><router-link to="monthlyshareanalysis">Monthly Shares Analysis</router-link></li>
                </ul>
              </div>
              <div class="col-md-3" v-show="userData.permissions['loans_report'] == 1">
                <h5 class="font-size-14 mt-0">Loan Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="loanspermember">Loans Per Member</router-link></li>
                  <li><router-link to="loanpaymentreport">Loan Payment Reports</router-link></li>
                  <li><router-link to="writtenoffloans">Written Off Loans</router-link></li>
                  <li><router-link to="dueloans">Due Loans</router-link></li>
                  <li><router-link to="loanperproducts">Loans Per Loan Products</router-link></li>
                  <li><router-link to="loanmonthlyreport">Monthly Loan Analysis</router-link></li>
                </ul>
              </div>
              <div class="col-md-3" v-show="userData.permissions['performance_reports'] == 1">
                <h5 class="font-size-14 mt-0">Performance Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="savingsperuser">Savings Per User</router-link></li>
                  <li><router-link to="withdrawsperuser">Withdraws Per User</router-link></li>
                  <li><router-link to="sharesperuser">Shares Per User</router-link></li>
                  <li><router-link to="loansperuser">Loans Per User</router-link></li>
                  <li><router-link to="transactionsreport">Transactions Report</router-link></li>
                  <li><router-link to="expensesreport">Expenses Report</router-link></li>
                </ul>
              </div>
              <div class="col-md-3" v-show="userData.permissions['other_reports'] == 1">
                <h5 class="font-size-14 mt-0">Other Reports</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="/inactiveaccounts">Inactive Member Accounts</router-link></li>
                  <li><router-link to="/withdrawchargesreport">Withdraw Charges Report</router-link></li>
                  <li><router-link to="/loaninterestsreport">Loan Interests Report</router-link></li>
                  <li><router-link to="/loanchargesreport">Loan Charges Report</router-link></li>
                  <li><router-link to="/membershipfeesport">Membership Fees Report</router-link></li>
                  <li><router-link to="/incomeandexpenditure">Income & Expenditure</router-link></li>
                </ul>
              </div>
            </div>
          </b-dropdown>
        </span>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <div class="dropdown-item border-bottom mb-2">
            <div class="text-secondary fs-5">{{ userData.member.name }}</div>
            <span class="d-block text-info fw-bold">{{ userData.member.member_id }}</span>
          </div>
          <router-link :to="{
            path: '/memberprofile',
            query: { id: userData.member.member_id },
          }" class="dropdown-item fw-bold">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>Full Profile
          </router-link>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>
